export default "__VITE_ASSET__coIn91dR__"